import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import * as CanvasJS from '../../canvasjs.min';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import  jspdf from 'jspdf';
import * as moment from 'moment';
import html2canvas from 'html2canvas';
declare let swal:any;
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { map } from 'jquery';
declare var $: any;
@Component({
  selector: 'app-comparison-of-annual-calculation',
  templateUrl: './comparison-of-annual-calculation.component.html',
  styleUrls: ['./comparison-of-annual-calculation.component.css']
})
export class ComparisonOfAnnualCalculationComponent implements OnInit {
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  form_id:any;
  getlistApi:any;
  selectallvalue:any;
  getfarmsListData:any;
  loadspeciesValue:any;
  getspeciesvalue:any;
  addUrl:any;
  dict:any;
  agegroupformap:any;
  getallarrayval=[];
  isLoading:true;
  speciesloaddata:any;
filteringarray=[];
  getData:any=[]; 
  getExportData:any=[]; 
  mean_sum: any=0.00;
  eadrgetvalue:any;
  annualTotalData:any;
  std_dv: any=0.00;
  eadr_one_std_dv: any=0.00;
  eadr_one_five_std_dv: any=0.00;
  eadr_two_dv: any=0.00;
  chartData:any;
  get_age:any;
  ageUrl :any;
  CanvasJS:any;
  farm_id:any;
  constructor(private router: Router,private commonService: CommonService,private formBuilder: FormBuilder) { }

  async ngOnInit() : Promise<void> {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      this.form_id=this.farm_userrole;
    }else{
    this.form_id=null;
    }
    this.isLoading =true;
    var table;
    $('#reportrange_date').daterangepicker('refresh');
    $('.selectpicker').selectpicker('refresh');
    //$('#reportrange_date').daterangepicker('refresh');
    //$('#reportrange_date').daterangepicker('setDate', 0);
    this.getlistApi=(this.form_id!=null)?'/farms/'+this.form_id:"/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async(res) => {
         $(function(){
         table = $("#myTable").DataTable();
         })
         this.getfarmsListData = (this.form_id!=null)?[res.data]:res.data;
         this.getfarmsListData.unshift({tnfr_id:null,tnfr_name:"Select Farm Name"});
  });
      
// species list..............

if(this.form_id!=null){
  this.getlistApi= "/species/?farm_user="+this.form_id;
 }
 else{
  this.getlistApi= "/species";
 }
(await this.commonService.getApi(this.getlistApi)).subscribe( 
  (res) => {

      this.speciesloaddata = res.data;
      this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
           setTimeout((res)=>{ 
      }, 1500);
    
     })   
// species list..............
// breed list..............
       this.getlistApi= "/breeds";
      //this.getlistApi= "/breeds";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
            this.getspeciesvalue = res.data;
            this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
    
        })   
 // breed list..............

  setTimeout(function () {
   $('#reportrange_date').daterangepicker('refresh');
    $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
    //$('#reportrange_date').daterangepicker('refresh');
 }, 1500);
 
 $('#farmname').change(async ()=> {
  $("#speciesid").find('option').remove().end();

    this.selectallvalue= $('#farmname').val();
    var farmvalue="";
farmvalue = this.selectallvalue.toString();
this.loadspeciesValue = {
"farms_id":farmvalue
};

if(farmvalue!="null"){
      //species load in select dropdown based on farm select api call
      this.addUrl = "/species/farms";
      (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
        res => {
          this.speciesloaddata=res.data;
          this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
          
          
        })
      }else{
        $('#Speciesname').val('null');
        this.speciesloaddata=[{id:null,name:"Select Species Name"}];
        $('#BreedName').val('null');
        this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
       $('#age').val('null');
       this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
      }
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
       }, 1500);
  });

  $(document).on('change', '#farmname', function() {
    $('.myFakeClass').dropdown('toggle');
  });
  $(document).on('change', '#Speciesname', function() {
    $('.myFakeClass1').dropdown('toggle');
  });
  $(document).on('change', '#BreedName', function() {
    $('.myFakeClass2').dropdown('toggle');
  });
  $(document).on('change', '#age', function() {
    $('.myFakeClass3').dropdown('toggle');
  });
  }
  
  async breedselectbyspecies(event){
   
    if(event.target.value!='null'){
    this.addUrl = "/breeds/species/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
           this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
     
      });
      this.ageUrl="/species/age_group/all_category/?species_id="+event.target.value;
      (await this.commonService.getApi(this.ageUrl)).subscribe(
        res => {
             this.get_age=res.data;
             this.get_age.unshift({tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'});
            
        });
     
    }else{
      $('#BreedName').val('null');
      this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
     $('#age').val('null');
     this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
    }   
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
  }

    
  date_format(dateObject) {
    var d = new Date(dateObject);
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1 ;
    var month1 ;
    if (day < 10) {
        day1 = "0" + day;
    }else{
       day1 = day;
    }
    if (month < 10) {
        month1 = "0" + month;
    }else{
       month1 =  month;
    }
    var date = year + "-" + month1;
  
    return date;
  };

  async get_datas(){ 
    this.getallarrayval=[];
    this.getData=[];
    var from_date = $("input[name='daterangepicker_start']" ).val();
    var to_date = $("input[name='daterangepicker_end']" ).val();
    console.log(from_date+''+to_date)
    //var farm_id=$('#farmname').val();
    var farm_id=(this.form_id!=null)?this.form_id:null;//$('#farmname').val();
    var species_id=$('#Speciesname').val();
    var breed_id=null;//$('#BreedName').val();
    var age=$('#age').val();

    if(age=='' || age==null || age=='null'){
      alert("Please choose the Age");return false;
    }

// monthly report generate
var reportlistApi1="/reports/monthly_report/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
(await this.commonService.getApi(reportlistApi1)).subscribe(
      (res) => {  

      }
)
// monthly generate end

//tharma changes annual

this.getlistApi="/reports/annual_report/?from_date="+this.date_format(from_date)+"&to_date="+this.date_format(to_date)+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
 (await this.commonService.getApi(this.getlistApi)).subscribe(
  async (res) => { 
   var dateStart = moment(from_date);
   var dateEnd = moment(to_date);
   var timeValues = [];
   while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
      timeValues.push(dateStart.format('YYYY-MM,MMMM'));
      dateStart.add(1,'month');
   }
     console.log(res.data)
   let result = [];

  var arr=[];
   timeValues.forEach(date => {
    
     var somedate=date.split(',')
     arr.push(somedate[0])
     const item = res.data.find(item =>item.date == somedate[0]);

     if (item) {
       result.push(item);
     } else {
      var date_=somedate[0];
      var year_=date_.split('-');
       if(result.length<=0){
        result.push({date: somedate[0],month:somedate[1], addition_count:0,opening_count:0,animal_days:0,total_count:0,deletion_count:0,current_balance:0,death_count:0,cumulative_stock:0,cumulative_addition:0, cumulative_total_count:0,cumulative_deletion:0,cumulative_animal_days:0,mortality_percentage:0,cumulative_current_balance:0,cumulative_death:0,year:year_[0]});
       }else{
        
        let lastElement = result[result.length - 1];
        //var opencount=lastElement.current_balance;
        let currentelement = result[result.length];
        var opencount=currentelement.opening_count;
        var totalcount=opencount;
        var deletioncount=lastElement.deletion_count;
        var currentbalance=totalcount-(deletioncount+lastElement.death_count);
        var cumulativestock=lastElement.cumulative_stock;
        var additionsinceseledate=0+lastElement.cumulative_addition;
        var totalsinceselectdate=cumulativestock+additionsinceseledate;
        var cumulativecurrenbal=totalsinceselectdate-0;
        var anidaysnor=lastElement.current_balance;

        var cumulativeanidays=lastElement.cumulative_animal_days;
       
        result.push({date: somedate[0],month:somedate[1], addition_count:0,opening_count:opencount,animal_days:anidaysnor,total_count:totalcount,deletion_count:0,current_balance:currentbalance,death_count:0,cumulative_stock:cumulativestock,cumulative_addition:additionsinceseledate, cumulative_total_count:totalsinceselectdate,cumulative_deletion:0,cumulative_animal_days:cumulativeanidays,mortality_percentage:0.00,cumulative_current_balance:cumulativecurrenbal,cumulative_death:0,year:year_[0]});
       }
    
     }
   })

   this.getData=[];
   this.getExportData=[];
    this.dict = [];
    let anima_days=0;
var cumulativeanimaldays;
 if(result.length>0){
let promise = Promise.resolve();
    for (let i = 0; i < result.length; i++) {
      promise = promise.then(() => (
        this.get_animal_days(result[i].date,i).then(async res => {
          this.eadrgetvalue=res;
          console.log(this.eadrgetvalue)
    this.getlistApi="/reports/annual_percentage_allfarms/?from_date="+this.date_format(from_date)+"&to_date="+this.date_format(to_date)+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
    var addform;
    (await this.commonService.getApi(this.getlistApi)).subscribe(
     (res) => {         
      console.log(res.data,'annual percentage');
      var annualdata = res.data;
      // annualdata.forEach(e=>{
      //   console.log(e.dataPoints.map(d=>d.y).reduce((o,n)=>o+n,0))
      // })

var val: number = annualdata.reduce((o,n)=> o+n.dataPoints.map(o=>typeof(o.y) == 'object' ? 0: o.y, console.log(o) ).reduce((o,n)=>o+n), 0)

      console.log(val, val/(annualdata.length-2), (annualdata.length-2), "total value");

      this.annualTotalData =val/(annualdata.length-2)
      // var { length } = annualdata;
      // console.log("total : ", total, "length : ", length)
    
      
      this.getExportData=res.data;
      console.log(this.getExportData)
   
   var arra1 = res.data.map(item => {
    console.log(item)
       var item2 = this.eadrgetvalue.find(i2 =>i2.farmname === item.name);
   
       if(item2!=undefined){
       item2= {dataPoints: [{
          x:0,
          y:item2.EADR
        }],
        'markerSize': 15,
        "name": item2.farmname,
        "showInLegend": true,
        "toolTipContent": "{name}: {y} ",
          type: "spline"} 
     
       }
   
      return item2 ? {...item2} : item;
     });
     const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      arr.slice(index, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      arr.slice(index)
    ]
      var totalsum=0;
      
    for(var l=0; l<this.eadrgetvalue.length; l++){

      console.log(this.eadrgetvalue,'eadrgetvalue');
      totalsum+=this.eadrgetvalue[l].EADR;
      console.log(totalsum,'totalsum')
      
    }
     var totalform=this.eadrgetvalue.length;
     console.log(totalform)
       var MeanEADR:any=this.annualTotalData;
       console.log(MeanEADR,'edr')
       
          
     
          var finalresultval;
          var removeValFrom = [0, 1];
          var valuesArr = arra1.filter(function(value, index) {
            return removeValFrom.indexOf(index) == -1;
       })
     
    
         /* finalresultval= insert(arra1, 2, {"color": "black",
          "dataPoints": [{x: 0,y: [MeanEADR,MeanEADR]}],
          "markerSize": 15,
          "name": "Men",
          "showInLegend": true,
          "toolTipContent": "{name}: {y[0]} - {y[1]}",
          "type": "error"}
          
          )*/
      //finalresultval =  insert(arra1, 2, )
  
         var getsquarearr=[];
       for(var l=0; l<this.eadrgetvalue.length; l++){
        //totalsum+=this.eadrgetvalue[l].EADR;
        var stddev=(MeanEADR-this.eadrgetvalue[l].EADR)
        console.log(stddev,'sd')
        var wholesquare=Math.pow(stddev, 2);
        
        getsquarearr.push(wholesquare)
      
        console.log(totalsum)
      }
     var standarddevadd=0;
      for(var m=0; m<getsquarearr.length; m++){
        standarddevadd+=getsquarearr[m]
      }
     
      var getstddev=1/5*standarddevadd;
      var finalstddevval=Math.sqrt(getstddev);
      var getdeviationval:any=finalstddevval;
      var meanplusstard=MeanEADR+getdeviationval;
      var meanminusstard=MeanEADR-getdeviationval;
    /*  finalresultval = insert(arra1, 1, {"color": "black",
   "dataPoints": [{y: [getdeviationval], label: 'young', x: 0}],
   "markerSize": 15,
   "name": "EADR (+SD , -SD) ",
   "showInLegend": true,
   "toolTipContent": "{name}: {y[0]} - {y[1]}",
   "type": "error"},
 )*/
 valuesArr.splice(0,0,{"color": "black",
 "dataPoints": [{y: [parseFloat(meanplusstard),meanminusstard], label: this.agegroupformap, x: 0}],
 "markerSize": 15,
 "name": "EADR (+SD , -SD) ",
 "showInLegend": true,
 "toolTipContent": "{name}: {y[0]} - {y[1]}",
 "type": "error"})
 valuesArr.splice(1,0,{"color": "black",
 "dataPoints": [{x: 0,y: [parseFloat(MeanEADR),parseFloat(MeanEADR)]}],
 "markerSize": 15,
 "name": "Mean",
 "showInLegend": true,
 "toolTipContent": "{name}: {y[0]} - {y[1]}",
 "type": "error"})
 
      
        var modifiedarray=valuesArr;
     
      // this.getData = res.data;
      this.getData =modifiedarray;
    console.log(this.getData)
      // let addtion:number=0.00;
       let std_dev:number=0.00;
       let sum_sd:number=0.00;
       let addtion:number=modifiedarray.map(function(row) {return row['y']; }).reduce((a, b) => a + b, 0);
      
        console.log('points=>',modifiedarray[1].dataPoints[0].y[0]); 
        this.mean_sum=modifiedarray[1].dataPoints[0].y[0];

        for (var i = 2; i < modifiedarray.length; i++) {
         sum_sd=Math.pow((parseFloat(modifiedarray[i].dataPoints[0].y)-parseFloat(this.mean_sum)),2) +sum_sd;
         console.log(sum_sd,'sd')
         
       }

        this.std_dv=Math.sqrt((sum_sd/modifiedarray.length)).toFixed(2);
        this.eadr_one_std_dv=(parseFloat(this.mean_sum)+parseFloat(this.std_dv)).toFixed(2);
        this.eadr_one_five_std_dv=(parseFloat(this.mean_sum)+(1.5 * parseFloat(this.std_dv))).toFixed(2);
        this.eadr_two_dv=(parseFloat(this.mean_sum)+(2* parseFloat(this.std_dv))).toFixed(2);
       console.log(this.mean_sum);
       
       var chart = new CanvasJS.Chart("chartContainer", {
         animationEnabled: true,
         
         toolTip: {
           shared: true
         },
         legend: {
             
             verticalAlign: "center",
             horizontalAlign: "left",
             fontSize: 15,
             //maxWidth: 200,
             itemMaxWidth: 300,
             itemWrap: true 
         },
        data: this.getData
       });
       chart.render();
    $('.canvasjs-chart-credit').css('display','none');
       
        })   
        })
    ));
     this.dict.push(result[i]);
    } 
  }
  var returnresult=await(cumulativeanimaldays)
  

 /* setTimeout(() => {
    this.filterarr()
  }, 6000);*/
 

    this.getExportData=this.dict;
    this.getData = this.dict;
    var getcallbackval=this.getData;

    /* setTimeout(() => {
       this.datagetpercent=getcallbackval.map(o =>{
         var percentnormaleadr=(o.death_count/o.ani_days*1000).toFixed(2);
         var percent=(o.cumulative_death/o.ani_cumulative_animal_days*1000).toFixed(2);

         return ({...o,cumulative_EADR:percent,Normal_EADR:percentnormaleadr})
          });
     }, 2000);*/
     
  

      }) ;



 // tharma changes annual and monthly


    //console.log($('div.date_range span').text());
  
  }

  
  public exportdata()
{
//var data = document.getElementById('contentToConvert');
let data = document.getElementById('contentToConvert');  
html2canvas(data).then(canvas => {
  const contentDataURL = canvas.toDataURL('image/png')  
  let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
  // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
  pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
  pdf.save('All_forms_under_one_species.pdf');   
}); 
}

//tharma annual changes
async get_animal_days(date,ind){
 
  var ani_from=date+"-01";
    var ani_to=this.endOfMonth(date);
  var getDaysArray = function(start, end) {
    for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
    var date=new Date(dt);
      var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();

        arr.push(y+'-' + (m <= 9 ? '0' + m : m)+ '-'+(d <= 9 ? '0' + d : d));
    }
    return arr;
};


  var from_date = ani_from;
  var to_date = ani_to;
  //var farm_id=($('#farmname').val()==null)?this.form_id:$('#farmname').val();
  var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
  var species_id=$('#Speciesname').val();
var breed_id=$('#BreedName').val();
var age=$('#age').val();

var getlistApi1="/reports/monthly_cumulative_allfarms/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+null+"&species_id="+species_id+"&breed_id="+null+"&age="+age;
//var daylist = getDaysArray(new Date(from_date),new Date(to_date));
var res=await(await this.commonService.getApi(getlistApi1)).toPromise()  
            
      var todate=to_date.split('-');
      var gettodate=todate[2];
      // const values = [{id: 10, name: 'someName1'}, {id: 10, name: 'someName2'}, {id: 11, name:'someName3'}, {id: 12, name: 'someName4'}];
    
        var dummyarray=[];
      for (var i = 0; i < res.data.length; i++) {
        const lookup = res.data.reduce((a, e) => {
          a[e.tnsm_farm_id] = ++a[e.tnsm_farm_id] || 0;
          console.log(res.data.farm_id,'formid');
          
          return a;
        }, {});
        dummyarray.push(lookup)
      }
      console.log(dummyarray)
   var samevalues= res.data.filter(e => dummyarray[e.tnsm_farm_id]);
   console.log(samevalues)
  
  if(samevalues.length>0){
    var opening_count='';
    var samevalueanimaldaysarr=[];
    var getopening_count=0;
    var sumofdeath=0;
    console.log(samevalues)
    for(var result=0;result<samevalues.length;result++){
      for(var i = 1; i <= parseInt(gettodate);i++){
      
      //  opening_count+=getopening_count;

        var getsamevaldate=samevalues[result].date.split('-');

        var resultgetsamevaldate=getsamevaldate[2];

        if(resultgetsamevaldate==i){
        
          getopening_count+=(samevalues[result].opening_count + samevalues[result].additon_count)-(samevalues[result].deletion_count + samevalues[result].death_count)
          sumofdeath+=samevalues[result].deletion_count + samevalues[result].death_count;
     
        }
    
     }
     console.log(samevalues[result].farm_name,samevalues[result].farm_id)
    var newobject={"farmname":samevalues[result].farm_name,"farmid":samevalues[result].tnsm_farm_id,"animaldays":getopening_count,"sumofdelanddeathcunt":sumofdeath}
    this.getallarrayval.push(newobject)
    console.log(this.getallarrayval)
    
    }
     
   }
   //getallarrayval.push(samevalueanimaldaysarr);
   if(samevalues.length>0){
    this.filteringarray.push(samevalues);
   }
   var nonsamevalues= res.data.filter(e => !dummyarray[e.farm_id]);

   console.log(res.data.farm_id,'formid');
   
   console.log(nonsamevalues,'nonsamevalues')
   if(nonsamevalues.length>0){
    var opening_count1='';
    var samevalueanimaldaysarr1=[];
    var getopening_count1=0;
    var sumofdeath1=0;
    for(var result=0;result<nonsamevalues.length;result++){
      for(var i = 1; i <= parseInt(gettodate);i++){
   
      //  opening_count+=getopening_count;
       
        var getsamevaldate=nonsamevalues[result].date.split('-');
        
        var resultgetsamevaldate1=getsamevaldate[2];

        if(resultgetsamevaldate1==i){

          getopening_count1+=(nonsamevalues[result].opening_count + nonsamevalues[result].additon_count)-(nonsamevalues[result].deletion_count + nonsamevalues[result].death_count)
          sumofdeath1+=nonsamevalues[result].deletion_count + nonsamevalues[result].death_count;
          
        }
    
     }
   console.log(nonsamevalues[result].farm_name,nonsamevalues[result].farm_id,'formid=>',nonsamevalues[result].farm_id )
    var newobject1={"farmname":nonsamevalues[result].farm_name,"farmid":nonsamevalues[result].tnsm_farm_id,"animaldays":getopening_count1,"sumofdelanddeathcunt":sumofdeath1}
    this.getallarrayval.push(newobject1)
    console.log( this.getallarrayval)
    }
   }

   console.log(this.getallarrayval)


 //  console.log(samevalueanimaldaysarr1);
  // console.log(samevalueanimaldaysarr);
   //getallarrayval.push(samevalueanimaldaysarr1);
  
   
      var getfarmid=[]
      let totalanimaldays=0;
    let totaldeletiondeath=0;
    if(totalanimaldays>0 || totaldeletiondeath>0){
      console.log('have value')
      console.log(totalanimaldays)
     }else{
      console.log('not have value')
      console.log(totalanimaldays)
     }
      console.log( this.getallarrayval)
      var initialvalue=0;
      var checkarry=[]
   var result1 = this.getallarrayval.reduce(function(r, o){
    var k = o.farmid ; 
      // unique `loc` key

      totalanimaldays+=o.animaldays

       totaldeletiondeath+= o.sumofdelanddeathcunt
   
       checkarry.push({farm_id:k,'totalanimaldays':o.animaldays,'totaldeletiondeath':o.sumofdelanddeathcunt})
    if ((r[k]=[])) r[k].push({farm_id:k,farmname:o.farmname, animal_days: totalanimaldays, deltionanddeath:totaldeletiondeath});
    return r;
}, {});

console.log(result1)
console.log(checkarry)
var keys=Object.keys(result1)

var finalcumulateresult=[]
let result2 = keys.filter((o:any) => [result1].find((x:any) => {
 // Object.keys(x).includes(o)
 if(Object.keys(x).includes(o)){

      var getarr=x[o];
   
      getarr.map((z:any)=>{
        var cumulativeanimal_days=0;
        var cumulativedeath=0;
        cumulativeanimal_days+=z.animal_days;
        cumulativedeath+=z.deltionanddeath
        var getcumulative={"farmname":z.farmname,"farmid":z.farm_id,"animaldays":cumulativeanimal_days,"cumulativedeath":cumulativedeath}
        finalcumulateresult.push(getcumulative);
        console.log(finalcumulateresult,'final')
      })
  }
 } ));

      var cumalativeEADR=[]
for(var y=0;y<finalcumulateresult.length;y++){
  var EADR=finalcumulateresult[y].cumulativedeath/finalcumulateresult[y].animaldays*1000
  console.log(EADR)
  var cumulativeEatr={"farmname":finalcumulateresult[y].farmname,EADR:EADR}
  console.log(cumulativeEatr)
  cumalativeEADR.push(cumulativeEatr);
}

console.log(cumalativeEADR);
   return cumalativeEADR;
/*for(var i=0;i<keys.length;i++){
    for(var j=0;j<result1.length;i++){

    }
}*/

     /* var lookup = {};
      var dummyarry=[];
      for (var i = 0, len = res.data.length; i < len; i++) {
        const result = Object.values(len.reduce((acc, cur) => {
          // Create a key from b,c,d..
          const key = cur.b + cur.c + cur.d
          acc[key] = acc[key] || { a: cur.a, e: 0 };
          acc[key].e += cur.e;
          return acc;
      }, {}))
      dummyarry.push(result)
      }
        console.log(dummyarry);*/

      /*this.opening_bal= (typeof res.data !== 'undefined' && res.data.length > 0)?res.data[0].opening_count:0; 
      let x=0; 
let j=0; 
let y=0;
let closing_tot=0;
let getData_count=[];

for(x=0;x<daylist.length;x++){
  for(j=0;j<res.data.length;j++){
    var arr=this.arrayColumn(getData_count, 'date');
    if(arr.includes(daylist[x])==false){
      if(res.data[j].date==daylist[x]){
        y=j+1;
        getData_count.push(res.data[j]);
        closing_tot=res.data[j].daily_closing_balance+closing_tot;
        //console.log('true',closing_tot);
      }else{
        var arr1=this.arrayColumn(getData_count, 'date');
       
        if(arr1.includes(res.data[j].date)==false ){
          //console.log("first",y);
          closing_tot=((y==0)?this.opening_bal:res.data[y-1].daily_closing_balance)+closing_tot;
          //console.log('true_else',closing_tot);
          getData_count.push({
            "date": daylist[x],
            "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
            "additon_count": 0,
            "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
            "death_count": 0,
            "deletion_count": 0,
            "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
          });
          
        }else{
          if(y==res.data.length){
            closing_tot=(y==0)?this.opening_bal:res.data[y-1].daily_closing_balance+closing_tot;
            //console.log("first2",closing_tot);
            getData_count.push({
              "date": daylist[x],
              "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "additon_count": 0,
              "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "death_count": 0,
              "deletion_count": 0,
              "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
            });
            
          }
        }

      }
      
    }
   // console.log(closing_tot);
  }
}

console.log(getData_count);
//var after_forloop = ()=>{
  console.log(closing_tot)
  console.log(this.dict[ind].deletion_count,'test checkc')
  this.dict[ind]['ani_days']= closing_tot; 
  this.dict[ind]['opening_count']=  this.opening_bal; 
  this.dict[ind]['total_count']=(this.opening_bal+this.dict[ind].addition_count);
  this.dict[ind]['current_balance']=(this.opening_bal+this.dict[ind].addition_count)-(this.dict[ind].deletion_count+this.dict[ind].death_count);
 
        if(typeof res.data !== 'undefined' && res.data.length==0){
    
            this.dict[ind]['ani_days']=this.dict[ind-1]['ani_days'];
          
               }
        if(ind==0){
          this.dict[ind]['ani_cumulative_animal_days']= closing_tot;  
        }else {
          this.dict[ind]['ani_cumulative_animal_days']=this.dict[ind-1]['ani_cumulative_animal_days']+closing_tot;

        }*/


      
       

      // return false;
       //return closing_total;
}
  
filterarr(){
 /* console.log(this.filteringarray);
  var merged=[].concat.apply([],this.filteringarray)
  var seconddummyarray=[];
  for (var i = 0; i < merged.length; i++) {
   const lookup1 = merged.reduce((a, e) => {
     a[e.farm_id] = ++a[e.farm_id] || 0;
     return a;
   }, {});
   seconddummyarray.push(lookup1)
 }
 var samevalues1= merged.filter(e => seconddummyarray[e.farm_id]);
 var nonsamevalues1= merged.filter(e => !seconddummyarray[e.farm_id]);
 console.log(samevalues1);
 console.log(nonsamevalues1)*/

}

endOfMonth(date)
  {
    date= new Date(date) ; 
  return this.end_date_format(new Date(date.getFullYear(), date.getMonth() + 1, 0));
 
  }
  end_date_format(dateObject) {
    var d = dateObject;
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1 ;
    var month1 ;
    if (day < 10) {
        day1 = "0" + day;
    }else{
       day1 = day;
    }
    if (month < 10) {
        month1 = "0" + month;
    }else{
       month1 =  month;
    }
    var date = year + "-" + month1 + "-" + day1;
  
    return date;
  };


getyoung(e:any){
  console.log(e.target.value)
  if(e.target.value==2){
    this.agegroupformap='Adult'
  }else{
    this.agegroupformap='Young'
  }
}
}